import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
export const NotificationAlert: React.FunctionComponent<any> = ({ state, notificationMessage,alertType }: any) => {

  var  vertical:any='top', horizontal:any='right';
    return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar anchorOrigin={ {vertical, horizontal}} open={state} autoHideDuration={6000}>
      <Alert variant="filled" severity={alertType} sx={{ width: '100%' }}>
        {notificationMessage}
      </Alert>
      </Snackbar>
    </Stack>
  );
}
export default NotificationAlert;